import { styled, remCalc } from '../../lib/styles';
export const Spacer = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__Spacer",
  componentId: "ovd809-0"
})(["flex-shrink:0;width:", ";"], ({
  onlyAllDayEvents,
  theme: {
    uiAddonCalendars: {
      weekView: {
        spacerWidth,
        spacerWidthWithoutToggle
      }
    }
  }
}) => onlyAllDayEvents ? spacerWidthWithoutToggle : spacerWidth);
export const ContentWrapper = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__ContentWrapper",
  componentId: "ovd809-1"
})(["border:1px solid ", ";border-top:none;flex:1 1 auto;height:100%;overflow:", ";position:relative;width:100%;"], ({
  theme
}) => theme.color['border-core-subtle'], ({
  disableScrollIfPopoverOpen,
  hasPopoverOpen
}) => disableScrollIfPopoverOpen && hasPopoverOpen ? 'hidden' : 'auto');
export const Header = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__Header",
  componentId: "ovd809-2"
})(({
  theme: {
    uiAddonCalendars: {
      headerHeight
    },
    color
  },
  isWeekView,
  scrollbarWidth
}) => `
  background: ${color['fill-transitional-table-default']};
  border-left: 1px solid ${color['border-core-subtle']};
  border-top: 1px solid ${color['border-core-subtle']};
  border-bottom: ${isWeekView ? `1px solid ${color['border-core-subtle']}` : 'none'};
  color: ${color['text-core-default']};
  display: flex;
  height: ${headerHeight};
  flex-shrink: 0;
  padding-right: ${remCalc(scrollbarWidth)};
  * {
    font-size: ${remCalc(12)};
  }
`);
export const DayColumnWrapper = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__DayColumnWrapper",
  componentId: "ovd809-3"
})(["display:flex;height:100%;position:absolute;width:100%;"]);
export const RowWrapper = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__RowWrapper",
  componentId: "ovd809-4"
})(["border:1px solid ", ";", " border-top:0;display:flex;flex-shrink:0;position:relative;width:100%;"], ({
  theme
}) => theme.color['border-core-subtle'], ({
  isWeekView,
  scrollbarWidth
}) => isWeekView ? `padding-right: ${remCalc(scrollbarWidth)};` : '');

/* HOUR GRID */

export const HourMarker = styled.div.attrs({
  'data-test-id': 'hour-marker'
})(({
  theme: {
    uiAddonCalendars: {
      weekView: {
        spacerWidth,
        timeRowPadding
      }
    }
  }
}) => `
  flex-shrink: 0;
  padding-right: ${timeRowPadding};
  transform: translateY(-50%);
  width: calc(${spacerWidth} - ${timeRowPadding});
`);
export const HoursWrapper = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__HoursWrapper",
  componentId: "ovd809-5"
})(({
  theme: {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      }
    }
  }
}) => `
  padding-top: calc(${hourHeight} / 2);
  padding-bottom: calc(${hourHeight} / 2);
  width: 100%;
`);
export const HourRow = styled.div.withConfig({
  displayName: "DayWeekLayoutStyles__HourRow",
  componentId: "ovd809-6"
})(({
  theme: {
    uiAddonCalendars: {
      dayView: {
        hourHeight
      },
      weekView: {
        timeRowPadding
      }
    }
  }
}) => `
  align-items: flex-start;
  display: flex;
  height: ${hourHeight};
  padding-left: ${timeRowPadding};
  position: relative;
`);